import React from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal = ({ open, onClose, children }: ModalProps) => {
  return (
    <div
      onClick={onClose}
      className={` fixed inset-0 flex items-start justify-center overflow-y-auto pb-20 pt-20 text-center transition-colors ${
        open ? "bg-black/20 visible" : "invisible"
      }`}
      style={{ textAlign: "center" }}
    >
      <div
        className={`rounded-4xl my-auto w-[fill-available] justify-items-center p-8 shadow transition-all ${
          open ? "scale-100 opacity-100" : "scale-125 opacity-0"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

export default Modal;
